import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { MessageService } from "primeng/components/common/messageservice";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
declare var gapi: any

@Component({
    selector: 'teachers',
    templateUrl: 'teachers.component.html',
    styleUrls: ['teachers.component.scss'],

})
export class TeachersViewQuantaComponent implements OnInit {
  display = "none";
  display1 = "none";

  display2 = "none";
  display3 = "none";


    public SchoolYear: any; 
    public ShowLevelData: any;
    public selectedlevel: any; 
    public mappedData: any;
    public selectedgrade:  any;
    public selectedsection:  any
    public nameofsec:  any
    public sectionId:  any 
    public sectionList:  any
    public subjectsList:  any
    public selectedSubject:  any


    public SubjectsSemesterInfoData : any =[] ;
    public TeacherDetailsData : any = [];
    public TeacherId : any;
    public TeacherStdSectionData : any = [];
    public TeacherSectionData : any = [];
    public TeacherSubjectData : any = [];
    public SubTeacherId : any;
    public StandardId : any;
    public SectionId : any;
    public SubjectId : any;
    public ListOfSem : any = [];
    public SemArray : any = [];

    profilePictureUrlM: string = 'assets/images/teacher/maleteacherpropic.png';
    profilePictureUrlF: string = 'assets/images/teacher/femaleteacherpropic.png';


    
    constructor(private dataAnalyticsService: DataAnalyticsService, private localStorage: LocalStorageService) {
    }
    ngOnInit() {
      //this.GetTeacherDetails();
      // this.GetSubjectsSemestersInfo();
      this.getAcademicYear();
    }

    private getAcademicYear() {
      this.dataAnalyticsService
        .getAcadamicYearOfyears()
        .finally(() => {})
        .subscribe(
          (response) => {
            this.SchoolYear = response["yearList"];
            console.log("SchoolYear", this.SchoolYear);
            try {
              this.getLevelsName();
            } catch (error) {}
          },
          (error) => {
            this.SchoolYear = [];
            console.error(error);
          }
        );
    }

    private getLevelsName() {
      this.dataAnalyticsService
        .getLevel()
        ._finally(() => {})
        .subscribe((response) => {
          this.ShowLevelData = response;
          try {
            this.selectedlevel =  this.ShowLevelData[0].Id;
            //this.getClassSection(this.selectedlevel["Id"]);
            this.getLevelClassSection(this.selectedlevel);
          } catch (error) {
  
          }
          console.log("ShowLevelData", this.ShowLevelData);
      }, (error) => {
  
      });
    }
  
    getLevelsListById(){
      console.log("fffff", this.selectedlevel);
      this.getLevelClassSection(this.selectedlevel);
    }

    //------------------------Ex Grade 1,2,3, & A,B,C--------------------------------------------------------------

  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
            this.selectedgrade = mappedData[mappedData.length - 1];
            this.getSectionByGrade(this.selectedgrade);
            this.selectedsection = this.selectedgrade.Sections[0];
        } catch (error) {
          //window.location.reload();
        }

        try {
          this.nameofsec = this.selectedsection.sectionName;
          this.sectionId = this.selectedsection.SectionId;
        } catch (error) {

        }

    
      },
      error => {
          this.mappedData = [];
          this.sectionList = [];
          this.subjectsList = [];
          this.selectedgrade = null;
          this.selectedsection = null;
          this.selectedSubject = null;
      });
  };

  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    try {
        this.selectedsection = this.sectionList[0];
    } catch (error) {

    }
  }

getGclClassesListById(section) {
  this.nameofsec = section.sectionName;
  this.sectionId = section.SectionId;
  //this.getStudentData(this.standardId,section.SectionId,this.yearId)
  console.log('getGclClassesListById', section);
}


////////////////////////////****************************************************************************** */


    private GetSubjectsSemestersInfo(SectionId,SubjectId,SemesterId) {
        this.dataAnalyticsService.GetSubjectsSemestersInfo(SectionId,SubjectId,SemesterId)._finally(() => { }).subscribe(
          response => {
            this.SubjectsSemesterInfoData = response;
            this.SubjectsSemesterInfoData.reverse();
            console.log(this.SubjectsSemesterInfoData )
          }
        )
      }

      private GetTeacherDetails(){
        this.dataAnalyticsService.getTeacherDetails()._finally(()=> { }).subscribe(
          response => {
            this.TeacherDetailsData = response['teacherdetailList'];
            console.log(this.TeacherDetailsData);
          }
        )
      }

      getTeachersName(teacher){
        this.TeacherStdSectionData = [];
        this.TeacherSectionData = [];
        this.TeacherSubjectData = [];
        this.SubjectsSemesterInfoData = [];
        this.TeacherId = teacher.teacherid
        this.GetTeacherStdSection(this.TeacherId)
        console.log(teacher);
      }

      private GetTeacherStdSection(teacherid){
        this.dataAnalyticsService.getTeacherStdSection(teacherid)._finally(()=> { }).subscribe(
          response => {
            this.TeacherStdSectionData = response['teachersStdList'];
            console.log(this.TeacherStdSectionData);
          }
        )
      }

      getTeachersGrade(grade){
        this.TeacherSubjectData = [];
        this.TeacherSectionData = [];
        this.SubjectsSemesterInfoData = [];
        this.SubTeacherId= grade.teacherid;
        // this.SectionId= grade.sectionid;
        this.StandardId = grade.stdid;
        // this.GetTeacherSubjects(this.SectionId,this.SubTeacherId)
        this.GetTeacherSection(this.SubTeacherId,this.StandardId)
        console.log(grade);
      }

      private GetTeacherSection(teacherid,stdid){
        this.dataAnalyticsService.getTeacherSection(teacherid,stdid)._finally(()=> { }).subscribe(
          response => {
            console.log(response)
            this.TeacherSectionData = response['teachersSecList'];
            console.log(this.TeacherSectionData);
          }
        )
      }

      getSection(sec){
        this.SectionId= sec.sectionid;
        console.log(sec)
        this.GetTeacherSubjects(this.SectionId,this.SubTeacherId)
      }


      private GetTeacherSubjects(SectionId,SubTeacherId){
        this.SemArray =[];
        this.dataAnalyticsService.getTeacherSubjects(SectionId,SubTeacherId)._finally(()=> { }).subscribe(
          response => {
            console.log(response)
            this.TeacherSubjectData = response['teachersubjectsList'];
            console.log(this.TeacherSubjectData);
            this.ListOfSem= this.TeacherSubjectData[1];
            // console.log( this.ListOfSem);
            this.ListOfSem.forEach(element => {
              element["SemesterId"] = element.SemesterId;
              this.SemArray.push(element["SemesterId"])
              console.log(this.SemArray)
            });
            // var i ;
            //  for(i=0; i<this.ListOfSem.length; i++){
            //   var data = { "semesterId": this.ListOfSem[i].SemesterId }
            //   console.log('data',data)
            //  }
          }
        )
      }

      getTeachersSub(sub){
        this.SubjectId = sub.SubjectId;
        this.GetSubjectsSemestersInfo(this.SectionId,this.SubjectId,this.SemArray);
        console.log(sub)
      }

/***************************************************************************************************************************** */
      AddLevel() {
        this.display = "block";
      }
    
      ViewTeacher() {
        this.display1 = "block";
      }

      ViewTeacher1() {
        this.display2 = "block";
      }

      ViewTeacher2() {
        this.display3 = "block";
      }

      UpdateTeacher() {
        this.display = "block";
      }
    
      onCloseHandled() {
        this.display = "none";
        this.display1 = "none";

        this.display2 = "none";
        this.display3 = "none";
      }
    
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/Teachers/teachers.component.ts